var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRejected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.86 20.45C3.86 11.1142 11.2742 3.69995 20.61 3.69995C29.9458 3.69995 37.36 11.1142 37.36 20.45C37.36 29.7857 29.9458 37.2 20.61 37.2C11.2742 37.2 3.86 29.7857 3.86 20.45ZM4.86 20.45C4.86 29.1142 11.9458 36.2 20.61 36.2C29.2742 36.2 36.36 29.1142 36.36 20.45C36.36 11.7857 29.2742 4.69995 20.61 4.69995C11.9458 4.69995 4.86 11.7857 4.86 20.45Z",
    stroke: "#CE1111",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.36 29.2L20.61 22.45L13.86 29.2L11.86 27.2L18.61 20.45L11.86 13.7L13.86 11.7L20.61 18.45L27.36 11.7L29.36 13.7L22.61 20.45L29.36 27.2L27.36 29.2Z",
    fill: "#CE1111"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejected);
export default __webpack_public_path__ + "static/media/rejected.0b8726a9b945d94b25ebfce26360ac24.svg";
export { ForwardRef as ReactComponent };